import { render, staticRenderFns } from "./ChartOptimalMix.vue?vue&type=template&id=4fa58f28&scoped=true&lang=pug&"
import script from "./ChartOptimalMix.vue?vue&type=script&lang=js&"
export * from "./ChartOptimalMix.vue?vue&type=script&lang=js&"
import style0 from "./ChartOptimalMix.vue?vue&type=style&index=0&id=4fa58f28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa58f28",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardText,VCardTitle,VCol,VRow,VSelect,VSkeletonLoader,VSpacer})
